import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { IStreaming } from '../models/streaming.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StreamingData {

  constructor(
    private afDb: AngularFireDatabase
  ) { }

  getDataByEvent(clientId: string, eventId: string): Observable<IStreaming> {
    return this.afDb.object<IStreaming>(`/Clients/${clientId}/Events/${eventId}/Streaming`).valueChanges();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/streaming.ts